import React from "react";
import { Button } from "../../../components/ui/button";
import { WA_BASE_URL } from "../../../mock";
import useInViewOnce from "../useInViewOnce";

const FinalCTASection = () => {
  const [setRef, isInView] = useInViewOnce();

  const handleWhatsApp = () => {
    const url = `${WA_BASE_URL}?text=${encodeURIComponent(
      "Halo, saya mau pesan bumbu masak Aceh CINEURASA."
    )}`;
    window.open(url, "_blank");
  };

  return (
    <section
      ref={setRef}
      className={`mb-4 rounded-3xl border border-border 
    bg-gradient-to-r from-secondary via-background to-accent 
    px-4 py-6 text-center shadow-md md:mb-6 md:px-8 md:py-8
    ${isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
    transition-all duration-300 ease-out`}
    >
      <h2 className="text-base font-semibold tracking-tight text-foreground md:text-lg">
        Rasa Aceh Autentik, Jangan Cuma Dibayangin
      </h2>

      <p className="mt-2 text-xs text-muted-foreground md:text-sm">
        Buktikan sendiri di dapur kamu. Klik tombol di bawah untuk langsung
        terhubung ke WhatsApp admin CINEURASA.
      </p>

      <Button
        onClick={handleWhatsApp}
        className="mt-4 rounded-full bg-primary px-6 text-sm font-semibold 
      text-primary-foreground shadow-md transition-transform duration-200 
      ease-out hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-lg 
      active:translate-y-0"
      >
        Pesan Sekarang via WhatsApp
      </Button>
    </section>
  );
};

export default FinalCTASection;
